/**
 * Sistemas do Rafael — lista unica do "waffle" (app launcher) do topo.
 * PADRAO REUSAVEL: copie este arquivo + src/ui/appLauncher.js para outro projeto
 * e marque `atual: true` no sistema correspondente. So este arquivo muda por projeto.
 */
export const SISTEMAS = [
  { nome: 'AcessaHUOL', descricao: 'Acessos, chaves e visitas', url: 'https://acessahuol.pages.dev', icone: 'ph-key', cor: '#1f9d5c', atual: true },
  { nome: 'AGCOR', descricao: 'Gestao correcional', url: 'https://agcor.pages.dev', icone: 'ph-gavel', cor: '#5b4cc4', atual: false },
];